import { CanDeactivateFn } from '@angular/router';

/**
 * A routed component that may hold unsaved work (a wizard draft, a form). `confirmLeave()` is
 * asked before the route changes: return `true` to leave at once (nothing to lose, or already
 * saved), or a promise that resolves once the user has answered a "Discard?" dialog — the
 * component owns the dialog so its wording names what is being thrown away (design
 * `pages/forms.md`: "confirm before discarding unsaved changes").
 */
export interface UnsavedChangesAware {
  confirmLeave(): boolean | Promise<boolean>;
}

/** Functional `canDeactivate` guard delegating to the component's `confirmLeave()`. */
export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesAware> = (component) =>
  component?.confirmLeave ? component.confirmLeave() : true;
